import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { YearPipeModule } from 'app/shared/pipes/year.pipe.module';
import { DeliveryListComponent } from './delivery-list.component';
import { ReactivateBtnModule } from './shared/reactivate-btn/reactivate-btn.module';
import { DeliveryListViewComponent } from './delivery-list-view/delivery-list-view.component';
import { FavoriteBtnModule } from './shared/favorite-btn/favorite-btn.module';
import { DownloadBtnModule } from './shared/download-btn/download-btn.module';
import { ModalOfflineModule } from './shared/modal-offline/modal-offline.module';
import { ModalReactivateModule } from './shared/modal-reactivate/modal-reactivate.module';
import { HighlightSearch } from './shared/highlight/highlight.pipe';
import { ModalDownloadModule } from './shared/download-btn/modal-download/modal-download.module';
import { DeliveryThumbnailViewComponent } from './delivery-thumbnail-view/delivery-thumbnail-view.component';
import { DeliveryListService } from './delivery-list.service';
import { UnreadBtnModule } from './shared/unread-btn/unread-btn.module';

const includeComponents = [
  DeliveryListComponent,
  DeliveryListViewComponent,
  DeliveryThumbnailViewComponent,
  HighlightSearch,
];

@NgModule({
  imports: [
    IonicModule,
    CommonModule,
    ReactivateBtnModule,
    DownloadBtnModule,
    FavoriteBtnModule,
    ModalOfflineModule,
    ModalReactivateModule,
    ModalDownloadModule,
    FormsModule,
    UnreadBtnModule,
    YearPipeModule.forRoot(),
  ],
  declarations: includeComponents,
  exports: [...includeComponents],
  providers: [DeliveryListService],
})
export class DeliveryListModule {}
